import {useEffect, useState} from 'react';
import {useShallow} from 'zustand/react/shallow';

import {getStudentQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function useGetStudent() {
  const [isStudentLoading, setIsStudentLoading] = useState(
    () => useStudentDashboard.getState().student === null
  );

  const {
    setIsReloadingStudent,
    setOpenAssignments,
    setPastDueAssignments,
    setShouldReloadStudent,
    setStudent,
    shouldReloadStudent,
    student,
    updateStudentLastFetchedAt
  } = useStudentDashboard(
    useShallow((state) => ({
      setIsReloadingStudent: state.setIsReloadingStudent,
      setOpenAssignments: state.setOpenAssignments,
      setPastDueAssignments: state.setPastDueAssignments,
      setShouldReloadStudent: state.setShouldReloadStudent,
      setStudent: state.setStudent,
      shouldReloadStudent: state.shouldReloadStudent,
      student: state.student,
      updateStudentLastFetchedAt: state.updateStudentLastFetchedAt
    }))
  );

  useEffect(() => {
    if (student === null || shouldReloadStudent) {
      const query = getStudentQuery();

      if (shouldReloadStudent) {
        // Since we do need to update the student, but it should largely be the same
        // we have a separate flag for the initial load and reloads to avoid showing the loading spinner over the whole page.
        setIsReloadingStudent(true);
        query.invalidateInterest();
      }

      updateStudentLastFetchedAt();

      getStudentQuery()
        .getResourcePromise()
        .then((fetchedStudent) => {
          const fetchedStudentAssignmentInfo = fetchedStudent.getMeta().getAssignmentInfo();
          const fetchedOpenAssignments = fetchedStudentAssignmentInfo.get('open_assignments');
          const fetchedPastDueAssignments =
            fetchedStudentAssignmentInfo.get('past_due_assignments');

          setStudent(fetchedStudent);
          setOpenAssignments(fetchedOpenAssignments);
          setPastDueAssignments(fetchedPastDueAssignments);
        })
        .catch((error) => {
          // TODO: Add error state
          console.error(error);
        })
        .finally(() => {
          if (shouldReloadStudent) {
            setShouldReloadStudent(false);
            setIsReloadingStudent(false);
          } else {
            setIsStudentLoading(false);
          }
        });
    }
  }, [
    setIsReloadingStudent,
    setOpenAssignments,
    setPastDueAssignments,
    setShouldReloadStudent,
    setStudent,
    shouldReloadStudent,
    student,
    updateStudentLastFetchedAt
  ]);

  return isStudentLoading;
}
